module.exports = __webpack_public_path__ + "static/media/6. Create approval request.ff805d39.svg";